import { render, staticRenderFns } from "./SourceType.vue?vue&type=template&id=9f9e6a86&"
import script from "./SourceType.vue?vue&type=script&lang=ts&"
export * from "./SourceType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports